import React from 'react';
import { Input } from 'antd';
import { FontSizeOutlined } from '@ant-design/icons';
import { getWordCount, getCharCount, estimateDuration, formatDuration } from '../../utils/text-stats';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { useEditorContext } from '../../context/editor-context';

const { TextArea } = Input;

/** Reuses the same updateScene pattern from the original RightPanel */
export const ScriptSection: React.FC = () => {
  const { scene, activeIndex, updateScene } = useEditorContext();
  const { spacing, fontSize } = useResponsiveSizes();
  const words = getWordCount(scene.script);
  const chars = getCharCount(scene.script);
  const duration = estimateDuration(scene.script);

  return (
    <div style={{ marginBottom: spacing.lg }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: spacing.sm }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: spacing.xs }}>
          <span
            style={{
              width: 22,
              height: 22,
              borderRadius: 6,
              background: C.surface,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: C.textSecondary,
              fontSize: fontSize.sm
            }}
          >
            <FontSizeOutlined />
          </span>
          <span
            style={{
              fontSize: fontSize.md,
              fontWeight: 600,
              color: C.textPrimary
            }}
          >
            Guion de la escena
          </span>
        </div>
      </div>

      {/* TextArea — same autoSize config as original RightPanel */}
      <TextArea
        value={scene.script}
        onChange={e => updateScene(activeIndex, 'script', e.target.value)}
        placeholder='Escribí el texto que va a leer el avatar...'
        autoSize={{ minRows: 6, maxRows: 16 }}
        style={{ borderRadius: 8, fontSize: fontSize.lg, lineHeight: 1.65 }}
      />

      {/* Stats footer — powered by text-stats utility */}
      <div
        style={{
          display: 'flex',
          gap: spacing.md,
          marginTop: spacing.xs,
          fontSize: fontSize.sm,
          color: C.textMuted
        }}
      >
        <span>{words} palabras</span>
        <span>{chars} caracteres</span>
        <span>~{formatDuration(duration)}</span>
      </div>
    </div>
  );
};
